module.exports = __webpack_public_path__ + "static/img/cif-do.1f6044a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-do.svg
// module id = delo
// module chunks = 2